module.exports = __webpack_public_path__ + "static/carafe-small-5e6752f59af33734d5e5e1fdc80ac218.jpg";